import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FakturaService {

constructor() { }
  dajVrednostPreRabataStavke(kolicina: number, cena: number): number {
    if (kolicina!=null && cena!=null)
      return rounding(kolicina*cena, 2);
  }

  dajRabatStavkeProc(
    kolicina: number
    , cena: number
    , rabatProc: number
  ): number {
    if (kolicina!=null && cena!=null && (rabatProc!=null && !Number.isNaN(rabatProc)))
      return rounding(kolicina*cena*rabatProc/100, 2);
   //else
   // return null;
  }

  dajRabatStavkeVred(
    kolicina: number
    , rabatVred: number
  ): number {
    if (kolicina!=null && rabatVred!=null)
      return rounding(kolicina*rabatVred, 2);
    //else
    //  return null;
  }

  dajOsnovicaStavke(
    vrednostPreRabataStavke: number
    , rabatStavke: number
  ): number{
    if (vrednostPreRabataStavke!=null && rabatStavke!=null)
      return vrednostPreRabataStavke-rabatStavke;
  }

  dajPdvStavke(
    osnovicaStavke: number
    , stopa: number
  ): number{
    if (osnovicaStavke!=null && stopa!=null)
      return rounding(osnovicaStavke*stopa/100, 2);

  }

  dajVrednostStavke(
    osnovicaStavke: number
    , pdvStavke:number
  ):number{
    if (osnovicaStavke!=null && pdvStavke!=null)
      return rounding(osnovicaStavke+pdvStavke , 2);
  }

  // dajCenaSaPdv(cena: number, rabatVred:number, stopa: number):number{
  //   if (cena != null && rabatVred != null && stopa != null)
  //     return rounding((cena - rabatVred) * (100 + stopa) / 100 , 2);
  // }

  dajCenaSaPdv(cena: number, rabatProc: number, stopa: number, rabatTip: number, rabatVred: number):number{    
    if (cena != null && rabatProc == null && stopa == null)
      return rounding(cena,2);
    if (cena != null && rabatProc != null && stopa == null)
      return rounding(rounding(rabatTip==0 ? cena - cena * rabatProc / 100 : cena - rabatVred,2) , 2);
    if (cena != null && rabatProc == null && stopa != null)
      return rounding(cena * (100 + stopa) / 100 , 2);
    if (cena != null && rabatProc != null && stopa != null)
      return rounding(rounding(rabatTip==0 ? cena - cena * rabatProc / 100 : cena - rabatVred,2) * (100 + stopa) / 100 , 2);
  }

  dajRabatVredPoJM(cena: number, rabatProc: number):number{
    if(cena != null && rabatProc != null && !Number.isNaN(rabatProc) && !Number.isNaN(cena))
    // if(cena != null && rabatProc != null && !Number.isNaN(rabatProc))
      return rounding(cena * rabatProc / 100, 2);
    else
      return null;
  }

  dajRSDCenu(cenaUValuti: number, kurs: number, brojDecimala: number):number{
    if (cenaUValuti != null && kurs != null)
      return rounding(cenaUValuti * kurs, brojDecimala);
  }

  dajRabatProc(rabatVred: number, cena: number): number{
    if (rabatVred != null && cena != null && cena != 0 && !Number.isNaN(rabatVred))
      return rounding(rabatVred / cena * 100, 2);
  }
}

function rounding(number: number, precision: number): number{
  return Number((Math.round(Number(number + "e+" + precision)) +"e-" + precision));
}
